<nav class="navbar navbar-expand-lg navbar-light bg-white qai-navbar-secondary">
    <div class="container-fluid px-0">
        <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
            <div class="navbar-nav">
                @if (navList.length > 1) {
                <button class="nav-link" aria-current="page" [routerLink]="navList[navList.length - 2].routePath">
                    <fa-icon class="qai-nav-icon px-2 py-1" [icon]="faArrowLeft"></fa-icon>
                </button>
                }
                @for (navLink of navList; track $index) {
                @if (!$last) {
                <button class="nav-link" aria-current="page" [routerLink]="navLink.routePath">{{navLink.label}}</button>
                <div class="vr my-2"></div>
                } @else {
                <button class="nav-link active" aria-current="page" [routerLink]="navLink.routePath">
                    @if (navLink.loading) {
                    <span class="placeholder-glow" aria-hidden="true">
                        <span class="placeholder col-12" style="min-width: 6rem;"></span>
                    </span>
                    <span class="visually-hidden">Caricamento in corso</span>
                    } @else {
                    {{ navLink.label }}
                    }
                </button>
                }
                }
            </div>
        </div>
        @if (search) {
        <form class="w-25" [class.me-2]="createButton !== 'hide'">
            <div class="input-group">
                <fa-icon [icon]="faSearch" class="search-icon" style="color: lightgrey; z-index: 10;"></fa-icon>
                <input class="form-control qai-form-control_search bg-light rounded-3" type="search"
                    [placeholder]="searchPlaceholder" [(ngModel)]="searchTerm"
                    (ngModelChange)="searchEvent.emit(searchTerm)" [ngModelOptions]="{standalone: true}" i18n-aria-label
                    aria-label="Search">
            </div>
        </form>
        }
        @if (createButton !== 'hide') {
        <button class="btn btn-primary" type="button" [routerLink]="navList[0].routePath + '/new'"
            [disabled]="createButton === 'disabled'" i18n>
            Crea {{ entityName }}
        </button>
        }
        @if (helperQuotaRequest) {
        <button class="btn btn-primary me-2" type="button" (click)="openUtilizationModal()" i18n>
            Richiedi estensione del servizio
        </button>
        }
        @if (filters && filters.length > 0) {
        <div ngbDropdown class="d-inline-block" (openChange)="onDropdownChange($event)" [autoClose]="false"
            #filterDropdown="ngbDropdown">
            <button type="button" class="btn btn-primary te-outline-primary" id="filter" ngbDropdownToggle>
                {{ filterButtonPlaceholder }}
            </button>
            <div ngbDropdownMenu aria-labelledby="filter"
                class="dropdown-menu dropdown-menu-end qai-filter-dropdown py-0 rounded-3 border-0 shadow-sm">
                <!-- select all -->
                <div class="px-3 py-2 bg-light rounded-top-3">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" id="selectAll"
                            [checked]="isAllFiltersSelected()" (change)="selectAll($event)">
                        <label class="form-check-label" for="selectAll">
                            Seleziona tutto
                        </label>
                    </div>
                </div>
                @for (filter of filters; track $index) {
                <div class="px-3 py-1">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" [id]="filter.value" [value]="filter.value"
                            [(ngModel)]="filter.selected">
                        <label class="form-check-label" [for]="filter.value">
                            {{ filter.label }}
                        </label>
                    </div>
                </div>
                }
                <div class="d-flex justify-content-center my-2">
                    <button type="button" class="btn btn-primary" (click)="filterDropdown.close()">
                        Conferma
                    </button>
                </div>
            </div>
        </div>
        }
    </div>
</nav>